export const GRAMMAR_TASKS_DATA: { [key: string]: any } = {
    // Beginner Level 1
    'present-simple-1': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'I _____ to school every day.', correctAnswer: 'go', placeholderHint: 'go' },
            { id: 'q2', text: 'She _____ English very well.', correctAnswer: 'speaks', placeholderHint: 'speak' },
            { id: 'q3', text: 'They _____ football on weekends.', correctAnswer: 'play', placeholderHint: 'play' },
            { id: 'q4', text: 'He _____ coffee in the morning.', correctAnswer: 'drinks', placeholderHint: 'drink' },
            { id: 'q5', text: 'We _____ our homework every evening.', correctAnswer: 'do', placeholderHint: 'do' },
            { id: 'q6', text: 'My sister _____ in London.', correctAnswer: 'lives', placeholderHint: 'live' },
            { id: 'q7', text: 'The sun _____ in the east.', correctAnswer: 'rises', placeholderHint: 'rise' },
            { id: 'q8', text: 'Birds _____ in the sky.', correctAnswer: 'fly', placeholderHint: 'fly' },
            { id: 'q9', text: 'Water _____ at 0°C.', correctAnswer: 'freezes', placeholderHint: 'freeze' }
        ]
    },
    'present-continuous-1': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'I _____ a book right now.', correctAnswer: 'am reading', placeholderHint: 'read' },
            { id: 'q2', text: 'She _____ on her project.', correctAnswer: 'is working', placeholderHint: 'work' },
            { id: 'q3', text: 'They _____ football in the park.', correctAnswer: 'are playing', placeholderHint: 'play' },
            { id: 'q4', text: 'He _____ TV at the moment.', correctAnswer: 'is watching', placeholderHint: 'watch' },
            { id: 'q5', text: 'We _____ for our exam.', correctAnswer: 'are studying', placeholderHint: 'study' }
        ]
    },
    'past-simple-1': {
        instructions: 'Select the correct past simple form for each sentence.',
        questions: [
            { id: 'q1', text: 'I _____ to the store yesterday.', options: ['went', 'go', 'going', 'gone'], correctAnswer: 'went' },
            { id: 'q2', text: 'She _____ lunch at 12 PM.', options: ['ate', 'eat', 'eaten', 'eating'], correctAnswer: 'ate' },
            { id: 'q3', text: 'They _____ tennis last weekend.', options: ['played', 'play', 'playing', 'plays'], correctAnswer: 'played' },
            { id: 'q4', text: 'He _____ a movie last night.', options: ['watched', 'watch', 'watching', 'watches'], correctAnswer: 'watched' },
            { id: 'q5', text: 'We _____ our grandparents.', options: ['visited', 'visit', 'visiting', 'visits'], correctAnswer: 'visited' }
        ]
    },
    'past-continuous-1': {
        instructions: 'Select the correct past continuous form for each sentence.',
        questions: [
            { id: 'q1', text: 'I _____ TV when you called.', options: ['was watching', 'were watching', 'watched', 'am watching'], correctAnswer: 'was watching' },
            { id: 'q2', text: 'They _____ football when it started raining.', options: ['were playing', 'was playing', 'played', 'are playing'], correctAnswer: 'were playing' },
            { id: 'q3', text: 'She _____ at 8 PM yesterday.', options: ['was studying', 'were studying', 'studied', 'is studying'], correctAnswer: 'was studying' },
            { id: 'q4', text: 'We _____ dinner when the phone rang.', options: ['were eating', 'was eating', 'ate', 'are eating'], correctAnswer: 'were eating' },
            { id: 'q5', text: 'He _____ home when he saw the accident.', options: ['was driving', 'were driving', 'drove', 'is driving'], correctAnswer: 'was driving' }
        ]
    },
    'future-simple-2': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'I _____ to the movies tomorrow.', correctAnswer: 'will go', placeholderHint: 'go' },
            { id: 'q2', text: 'She _____ her work by 5 PM.', correctAnswer: 'will finish', placeholderHint: 'finish' },
            { id: 'q3', text: 'They _____ at 8 o\'clock.', correctAnswer: 'will arrive', placeholderHint: 'arrive' },
            { id: 'q4', text: 'He _____ you later.', correctAnswer: 'will call', placeholderHint: 'call' },
            { id: 'q5', text: 'We _____ at the restaurant.', correctAnswer: 'will meet', placeholderHint: 'meet' },
            { id: 'q6', text: 'I _____ ready in five minutes.', correctAnswer: 'will be', placeholderHint: 'be' },
            { id: 'q7', text: 'She _____ for the exam tonight.', correctAnswer: 'will study', placeholderHint: 'study' },
            { id: 'q8', text: 'They _____ to Europe next summer.', correctAnswer: 'will travel', placeholderHint: 'travel' }
        ]
    },
    'sentence-structure-1': {
        instructions: 'Fill in the correct word or phrase',
        questions: [
            { id: 'q1', text: 'I _____ to school every morning.', correctAnswer: 'walk', placeholderHint: 'walk' },
            { id: 'q2', text: 'She _____ her homework after dinner.', correctAnswer: 'does', placeholderHint: 'do' },
            { id: 'q3', text: 'They _____ in the park on weekends.', correctAnswer: 'play', placeholderHint: 'play' },
            { id: 'q4', text: 'My brother _____ very fast.', correctAnswer: 'runs', placeholderHint: 'run' },
            { id: 'q5', text: 'We _____ coffee in the morning.', correctAnswer: 'drink', placeholderHint: 'drink' }
        ]
    },
    'verb-patterns-1': {
        instructions: 'Fill in the correct verb pattern',
        questions: [
            { id: 'q1', text: 'I enjoy _____ books.', correctAnswer: 'reading', placeholderHint: 'read' },
            { id: 'q2', text: 'She wants _____ a doctor.', correctAnswer: 'to be', placeholderHint: 'be' },
            { id: 'q3', text: 'They decided _____ home early.', correctAnswer: 'to go', placeholderHint: 'go' },
            { id: 'q4', text: 'He finished _____ his room.', correctAnswer: 'cleaning', placeholderHint: 'clean' },
            { id: 'q5', text: 'We need _____ now.', correctAnswer: 'to leave', placeholderHint: 'leave' }
        ]
    },
    'voice-clauses-1': {
        instructions: 'Select the correct form to complete each sentence.',
        questions: [
            { id: 'q1', text: 'The cake _____ by my mother.', options: ['was baked', 'baked', 'is bake', 'baking'], correctAnswer: 'was baked' },
            { id: 'q2', text: 'This is the boy _____ helped me.', options: ['who', 'which', 'where', 'when'], correctAnswer: 'who' },
            { id: 'q3', text: 'The car _____ yesterday.', options: ['was washed', 'washed', 'is washed', 'wash'], correctAnswer: 'was washed' },
            { id: 'q4', text: 'The book _____ is on the table is mine.', options: ['that', 'which', 'who', 'where'], correctAnswers: ['that', 'which'] },
            { id: 'q5', text: 'English _____ in many countries.', options: ['is spoken', 'speaks', 'spoke', 'speaking'], correctAnswer: 'is spoken' }
        ]
    },
    'modal-verbs-1': {
        instructions: 'Select every modal that matches the meaning stated in the sentence.',
        questions: [
            { id: 'q1', text: 'I _____ swim when I was five years old.', options: ['can', 'could', 'should', 'must'], correctAnswers: ['could'], multiSelect: true },
            { id: 'q2', text: 'As advice, the nurse says you _____ see a doctor if you still feel sick tomorrow.', options: ['can', 'could', 'should', 'must'], correctAnswers: ['should'], multiSelect: true },
            { id: 'q3', text: 'She _____ speak three languages fluently; this is a present ability.', options: ['can', 'could', 'should', 'must'], correctAnswers: ['can'], multiSelect: true },
            { id: 'q4', text: 'As an offer, we _____ help you with your homework if you would like.', options: ['can', 'could', 'should', 'must'], correctAnswers: ['can', 'could'], multiSelect: true },
            { id: 'q5', text: 'The sign states a strict prohibition: You _____ not park here.', options: ['can', 'could', 'should', 'must'], correctAnswers: ['must'], multiSelect: true },
        ]
    },
    'conditionals-basic-1': {
        instructions: 'Fill in the correct form',
        questions: [
            { id: 'q1', text: 'If it is sunny, we _____ to the park.', correctAnswer: 'go', placeholderHint: 'go' },
            { id: 'q2', text: 'If you heat water, it _____.', correctAnswer: 'boils', placeholderHint: 'boil' },
            { id: 'q3', text: 'If I am tired, I _____ early.', correctAnswer: 'sleep', placeholderHint: 'sleep' },
            { id: 'q4', text: 'If she studies, she _____ good grades.', correctAnswer: 'gets', placeholderHint: 'get' },
            { id: 'q5', text: 'If they leave now, they _____ on time.', correctAnswer: 'arrive', placeholderHint: 'arrive' }
        ]
    },
    'prepositions-1': {
        instructions: 'Select the correct preposition of time for each sentence.',
        questions: [
            { id: 'q1', text: 'I was born _____ 1990.', options: ['in', 'on', 'at'], correctAnswer: 'in' },
            { id: 'q2', text: 'The meeting is _____ Monday.', options: ['in', 'on', 'at'], correctAnswer: 'on' },
            { id: 'q3', text: 'We usually have lunch _____ noon.', options: ['in', 'on', 'at'], correctAnswer: 'at' },
            { id: 'q4', text: 'She goes to the gym _____ the morning.', options: ['in', 'on', 'at'], correctAnswer: 'in' },
            { id: 'q5', text: 'The party starts _____ 8 PM.', options: ['in', 'on', 'at'], correctAnswer: 'at' },
            { id: 'q6', text: 'He was born _____ a Thursday.', options: ['in', 'on', 'at'], correctAnswer: 'on' },
            { id: 'q7', text: 'The shop opens _____ midnight.', options: ['in', 'on', 'at'], correctAnswer: 'at' },
            { id: 'q8', text: 'We go on holiday _____ summer.', options: ['in', 'on', 'at'], correctAnswer: 'in' },
        ]
    },
    'prepositions-2': {
        instructions: 'Select the correct preposition of place for each sentence.',
        questions: [
            { id: 'q1', text: 'The book is _____ the table.', options: ['on', 'in', 'under', 'between'], correctAnswer: 'on' },
            { id: 'q2', text: 'She lives _____ London.', options: ['on', 'in', 'at', 'under'], correctAnswer: 'in' },
            { id: 'q3', text: 'The cat is hiding _____ the bed.', options: ['on', 'in', 'under', 'between'], correctAnswer: 'under' },
            { id: 'q4', text: 'He is standing _____ the door.', options: ['on', 'by', 'in', 'under'], correctAnswer: 'by' },
            { id: 'q5', text: 'The picture is hanging _____ the wall.', options: ['in', 'on', 'at', 'by'], correctAnswer: 'on' },
            { id: 'q6', text: 'The keys are _____ the drawer.', options: ['on', 'at', 'in', 'between'], correctAnswer: 'in' },
            { id: 'q7', text: 'She sat _____ her two friends.', options: ['on', 'in', 'between', 'under'], correctAnswer: 'between' },
            { id: 'q8', text: 'The café is _____ the corner.', options: ['in', 'on', 'under', 'between'], correctAnswer: 'on' },
        ]
    },
    'comparatives-1': {
        instructions: 'Categorize the adjectives into their correct forms.',
        dragDrop: {
            id: 'comparatives-1',
            items: [
                { id: 'a1', text: 'tall' },
                { id: 'a2', text: 'taller' },
                { id: 'a3', text: 'the tallest' },
                { id: 'a4', text: 'difficult' },
                { id: 'a5', text: 'more difficult' },
                { id: 'a6', text: 'the most difficult' },
                { id: 'a7', text: 'good' },
                { id: 'a8', text: 'better' },
                { id: 'a9', text: 'the best' }
            ],
            zones: [
                { id: 'base', label: 'Base Form' },
                { id: 'comparative', label: 'Comparative' },
                { id: 'superlative', label: 'Superlative' },
            ],
            correctMapping: {
                base: ['a1', 'a4', 'a7'],
                comparative: ['a2', 'a5', 'a8'],
                superlative: ['a3', 'a6', 'a9'],
            }
        }
    },
    'superlatives-1': {
        instructions: 'Fill in the correct superlative form',
        questions: [
            { id: 'q1', text: 'This is _____ place I have ever seen.', correctAnswer: 'the most beautiful', placeholderHint: 'beautiful' },
            { id: 'q2', text: 'He is _____ person in the class.', correctAnswer: 'the tallest', placeholderHint: 'tall' },
            { id: 'q3', text: 'This is _____ movie of the year.', correctAnswer: 'the best', placeholderHint: 'good' },
            { id: 'q4', text: 'She is _____ student in the school.', correctAnswer: 'the smartest', placeholderHint: 'smart' },
            { id: 'q5', text: 'This is _____ restaurant in town.', correctAnswer: 'the most expensive', placeholderHint: 'expensive' }
        ]
    },
    'comparisons-2': {
        instructions: 'Fill in the correct comparative or superlative form',
        questions: [
            { id: 'q1', text: 'This puzzle is _____ than the last one.', correctAnswer: 'more challenging', placeholderHint: 'challenging' },
            { id: 'q2', text: 'Mia is the _____ student in her group.', correctAnswer: 'most organized', placeholderHint: 'organized' },
            { id: 'q3', text: 'My commute is _____ now that I take the train.', correctAnswer: 'shorter', placeholderHint: 'short' },
            { id: 'q4', text: 'Of all three designs, this one is the _____.', correctAnswer: 'most practical', placeholderHint: 'practical' },
            { id: 'q5', text: 'The exam was _____ than we expected.', correctAnswer: 'easier', placeholderHint: 'easy' },
            { id: 'q6', text: 'This is the _____ explanation in the chapter.', correctAnswer: 'clearest', placeholderHint: 'clear' },
            { id: 'q7', text: 'Her second presentation was _____ than her first.', correctAnswer: 'more confident', placeholderHint: 'confident' },
            { id: 'q8', text: 'That route is the _____ way to the station at rush hour.', correctAnswer: 'fastest', placeholderHint: 'fast' }
        ]
    },
    'countable-uncountable-1': {
        instructions: 'Select ALL words that can correctly fill in the blank.',
        questions: [
            { id: 'q1', text: 'I need _____ water, please.', options: ['some', 'a', 'any', 'much', 'many'], correctAnswers: ['some', 'much'], multiSelect: true },
            { id: 'q2', text: 'There is _____ apple on the table.', options: ['some', 'an', 'a', 'two'], correctAnswers: ['an'], multiSelect: true },
            { id: 'q3', text: 'Do you have _____ information about this?', options: ['some', 'any', 'a', 'many'], correctAnswers: ['some', 'any'], multiSelect: true },
            { id: 'q4', text: 'I bought _____ new books yesterday.', options: ['some', 'a', 'any', 'many', 'much'], correctAnswers: ['some', 'many'], multiSelect: true },
            { id: 'q5', text: 'There isn\'t _____ milk in the fridge.', options: ['some', 'any', 'much', 'many'], correctAnswers: ['any', 'much'], multiSelect: true }
        ]
    },
    'pronouns-1': {
        instructions: 'Fill in the correct pronoun',
        questions: [
            { id: 'q1', text: '_____ am going to the store.', correctAnswer: 'I' },
            { id: 'q2', text: 'She gave Alex and _____ a present, and I thanked her.', correctAnswer: 'me' },
            { id: 'q3', text: 'Tom and Maya are my best friends. _____ are always kind to me.', correctAnswer: 'They' },
            { id: 'q4', text: 'I saw Daniel at the park and waved to _____.', correctAnswer: 'him' },
            { id: 'q5', text: 'Maya studies every evening. _____ is a very good student.', correctAnswer: 'She' }
        ]
    },
    'possessive-1': {
        instructions: 'Fill in the correct possessive form',
        questions: [
            { id: 'q1', text: 'I own this book. It is _____ book.', correctAnswer: 'my' },
            { id: 'q2', text: 'That car belongs to Maya. It is _____.', correctAnswer: 'hers' },
            { id: 'q3', text: 'Does this pen belong to you? Is this _____ pen?', correctAnswer: 'your' },
            { id: 'q4', text: 'I own the red bike. The red bike is _____.', correctAnswer: 'mine' },
            { id: 'q5', text: 'The Lee family lives here. _____ house is very beautiful.', correctAnswer: 'Their' }
        ]
    },
    'articles-2': {
        instructions: 'Fill in the correct article',
        questions: [
            { id: 'q1', text: 'At the zoo, I saw _____ elephant for the first time in my life.', correctAnswer: 'an', options: ['a', 'an', 'the', ''] },
            { id: 'q2', text: '_____ sun is shining brightly today.', correctAnswer: 'The', options: ['A', 'An', 'The', ''] },
            { id: 'q3', text: 'She is _____ honest person.', correctAnswer: 'an', options: ['a', 'an', 'the', ''] },
            { id: 'q4', text: '_____ book you gave me is very interesting.', correctAnswer: 'The', options: ['A', 'An', 'The', ''] },
            { id: 'q5', text: 'I need _____ umbrella because it\'s raining.', correctAnswer: 'an', options: ['a', 'an', 'the', ''] },
            { id: 'q6', text: '_____ only university in our city is located downtown.', correctAnswer: 'The', options: ['A', 'An', 'The', ''] },
            { id: 'q7', text: 'He is _____ European citizen.', correctAnswer: 'a', options: ['a', 'an', 'the', ''] },
            { id: 'q8', text: 'Thank you for the message. _____ information you provided was helpful.', correctAnswer: 'The', options: ['A', 'An', 'The', ''] }
        ]
    },
    'prepositions-advanced-2': {
        instructions: 'Drag each phrase into the correct preposition category.',
        dragDrop: {
            id: 'prepositions-advanced-2',
            items: [
                { id: 'p1', text: 'interested __' },
                { id: 'p2', text: 'succeeded __' },
                { id: 'p3', text: 'responsible __' },
                { id: 'p4', text: 'apologized __' },
                { id: 'p5', text: 'focuses __' },
                { id: 'p6', text: 'insisted __' },
                { id: 'p7', text: 'agreed __' },
                { id: 'p8', text: 'differ __' }
            ],
            zones: [
                { id: 'in', label: '... in' },
                { id: 'for', label: '... for' },
                { id: 'on', label: '... on' },
                { id: 'from', label: '... from' }
            ],
            correctMapping: {
                'in': ['p1', 'p2'],
                'for': ['p3', 'p4'],
                'on': ['p5', 'p6', 'p7'],
                'from': ['p8']
            }
        }
    },
    'present-perfect-2': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'I _____ my homework already.', correctAnswer: 'have finished', placeholderHint: 'finish' },
            { id: 'q2', text: 'She _____ Paris three times.', correctAnswer: 'has visited', placeholderHint: 'visit' },
            { id: 'q3', text: 'This is the first time they _____ such a beautiful sunset.', correctAnswer: 'have seen', placeholderHint: 'see' },
            { id: 'q4', text: 'We _____ here for five years.', correctAnswers: ['have lived', 'have been living'], placeholderHint: 'live' },
            { id: 'q5', text: 'He _____ breakfast yet.', correctAnswer: 'has not eaten', placeholderHint: 'eat' }
        ]
    },
    'past-perfect-2': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'By the time we arrived, the movie _____.', correctAnswer: 'had started', placeholderHint: 'start' },
            { id: 'q2', text: 'She _____ when I got there.', correctAnswer: 'had already left', placeholderHint: 'leave' },
            { id: 'q3', text: 'They _____ dinner before we arrived.', correctAnswer: 'had finished', placeholderHint: 'finish' },
            { id: 'q4', text: 'I _____ such a big dog before.', correctAnswer: 'had never seen', placeholderHint: 'see' },
            { id: 'q5', text: 'He _____ there for ten years before he quit.', correctAnswer: 'had worked', placeholderHint: 'work' }
        ]
    },
    'future-continuous-2': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'This time tomorrow, I _____ to Paris.', correctAnswer: 'will be flying', placeholderHint: 'fly' },
            { id: 'q2', text: 'At 8 PM tonight, she _____ for her exam.', correctAnswer: 'will be studying', placeholderHint: 'study' },
            { id: 'q3', text: 'At this time tomorrow, they _____ for you at the station.', correctAnswer: 'will be waiting', placeholderHint: 'wait' },
            { id: 'q4', text: 'We _____ dinner when you arrive.', correctAnswer: 'will be having', placeholderHint: 'have' },
            { id: 'q5', text: 'He _____ on his project all day tomorrow.', correctAnswer: 'will be working', placeholderHint: 'work' }
        ]
    },
    'modal-verbs-2': {
        instructions: 'Select every modal form that expresses the stated meaning.',
        questions: [
            { id: 'q1', text: 'The law requires drivers to wear a seatbelt: You _____ wear one when driving.', options: ['must', 'might', 'can', 'should'], correctAnswers: ['must'], multiSelect: true },
            { id: 'q2', text: 'The forecast gives a 40% chance of rain: It _____ rain later.', options: ['must', 'might', 'may', 'should'], correctAnswers: ['might', 'may'], multiSelect: true },
            { id: 'q3', text: 'The exam rules prohibit phones: Students _____ use them during the exam.', options: ['might not', 'may not', 'must not', 'cannot'], correctAnswers: ['may not', 'must not', 'cannot'], multiSelect: true },
            { id: 'q4', text: 'She _____ be at home, but I am not sure.', options: ['must', 'might', 'may', 'can'], correctAnswers: ['might', 'may'], multiSelect: true },
            { id: 'q5', text: 'Your parents require it: You _____ finish your homework before going out.', options: ['must', 'might', 'can', 'should'], correctAnswers: ['must'], multiSelect: true }
        ]
    },
    'conditionals-1': {
        instructions: 'Categorize the sentences into Zero or First Conditional.',
        dragDrop: {
            id: 'conditionals-1',
            items: [
                { id: 'c1', text: 'If you heat water, it boils.' },
                { id: 'c2', text: 'If it rains, I will stay at home.' },
                { id: 'c3', text: 'If you freeze water, it becomes solid.' },
                { id: 'c4', text: 'If she calls, I will tell her.' },
                { id: 'c5', text: 'If he leaves now, he will arrive on time.' },
                { id: 'c6', text: 'If you mix blue and yellow, you get green.' }
            ],
            zones: [
                { id: 'zero', label: 'Zero Conditional (General Truths)' },
                { id: 'first', label: 'First Conditional (Future Possibilities)' }
            ],
            correctMapping: {
                zero: ['c1', 'c3', 'c6'],
                first: ['c2', 'c4', 'c5']
            }
        }
    },
    'conditionals-2': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'If I _____ rich, I would travel the world.', correctAnswer: 'were', placeholderHint: 'be' },
            { id: 'q2', text: 'If she _____ more time, she would learn French.', correctAnswer: 'had', placeholderHint: 'have' },
            { id: 'q3', text: 'If it _____ tomorrow, we would go skiing.', correctAnswer: 'snowed', placeholderHint: 'snow' },
            { id: 'q4', text: 'If I _____ the answer, I would tell you.', correctAnswer: 'knew', placeholderHint: 'know' },
            { id: 'q5', text: 'If they _____ the lottery, they would buy a house.', correctAnswer: 'won', placeholderHint: 'win' }
        ]
    },
    'passive-voice-2': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'The book _____ by a famous author.', correctAnswer: 'was written', placeholderHint: 'write (past)' },
            { id: 'q2', text: 'English _____ all over the world.', correctAnswer: 'is spoken', placeholderHint: 'speak (present)' },
            { id: 'q3', text: 'The car _____ by the mechanic yesterday.', correctAnswer: 'was repaired', placeholderHint: 'repair (past)' },
            { id: 'q4', text: 'The letter _____ tomorrow.', correctAnswer: 'will be sent', placeholderHint: 'send (future)' },
            { id: 'q5', text: 'The house _____ last year.', correctAnswer: 'was built', placeholderHint: 'build (past)' }
        ]
    },
    'relative-clauses-2': {
        instructions: 'Select ALL relative pronouns that correctly complete the sentence.',
        questions: [
            { id: 'q1', text: 'The woman _____ lives next door is a doctor.', options: ['who', 'that', 'which', 'whom'], correctAnswers: ['who', 'that'], multiSelect: true },
            { id: 'q2', text: 'The book _____ I bought yesterday is very interesting.', options: ['that', 'which', 'who', 'whose'], correctAnswers: ['that', 'which'], multiSelect: true },
            { id: 'q3', text: 'This is the house _____ I grew up.', options: ['where', 'which', 'that', 'when'], correctAnswers: ['where'], multiSelect: true },
            { id: 'q4', text: 'The car _____ was parked outside belongs to my neighbor.', options: ['which', 'that', 'who', 'where'], correctAnswers: ['which', 'that'], multiSelect: true },
            { id: 'q5', text: 'The teacher _____ taught me English is very kind.', options: ['who', 'that', 'whom', 'which'], correctAnswers: ['who', 'that'], multiSelect: true }
        ]
    },
    'reported-speech-2': {
        instructions: 'Complete each report using standard backshift from the quoted words.',
        questions: [
            { id: 'q1', text: 'She said, "I am tired." → She said she _____ tired.', correctAnswer: 'was', placeholderHint: 'be' },
            { id: 'q2', text: 'He said, "I went to the store." → He told me he _____ to the store.', correctAnswer: 'had gone', placeholderHint: 'go' },
            { id: 'q3', text: 'They said, "We will come tomorrow." → They said they _____ the next day.', correctAnswer: 'would come', placeholderHint: 'come' },
            { id: 'q4', text: 'She asked, "Do you like coffee?" → She asked whether I _____ coffee.', correctAnswer: 'liked', placeholderHint: 'like' },
            { id: 'q5', text: 'He said, "I have been studying English for five years." → He said he _____ English for five years.', correctAnswer: 'had been studying', placeholderHint: 'study' }
        ]
    },
    'gerunds-infinitives-2': {
        instructions: 'Categorize the verbs by what follows them.',
        dragDrop: {
            id: 'gerunds-infinitives-2',
            items: [
                { id: 'v1', text: 'enjoy __' },
                { id: 'v2', text: 'want __' },
                { id: 'v3', text: 'decide __' },
                { id: 'v4', text: 'finish __' },
                { id: 'v5', text: 'need __' },
                { id: 'v6', text: 'avoid __' }
            ],
            zones: [
                { id: 'gerund', label: 'Followed by Gerund (e.g., doing)' },
                { id: 'infinitive', label: 'Followed by Infinitive (e.g., to do)' }
            ],
            correctMapping: {
                gerund: ['v1', 'v4', 'v6'],
                infinitive: ['v2', 'v3', 'v5']
            }
        }
    },
    'question-tags-2': {
        instructions: 'Fill in the correct question tag',
        questions: [
            { id: 'q1', text: 'You like coffee, _____?', correctAnswer: 'don\'t you' },
            { id: 'q2', text: 'She is a teacher, _____?', correctAnswer: 'isn\'t she' },
            { id: 'q3', text: 'They went to Paris, _____?', correctAnswer: 'didn\'t they' },
            { id: 'q4', text: 'He can swim, _____?', correctAnswer: 'can\'t he' },
            { id: 'q5', text: 'We should leave now, _____?', correctAnswer: 'shouldn\'t we' }
        ]
    },
    'pronouns-2': {
        instructions: 'Select ALL pronouns that grammatically fit in the blank.',
        questions: [
            { id: 'q1', text: 'Neither of the boys brought _____ notebook.', options: ['his', 'their', 'her', 'its'], correctAnswers: ['his', 'their'], multiSelect: true },
            { id: 'q2', text: 'The manager introduced _____ to the new clients.', options: ['himself', 'herself', 'themselves', 'itself'], correctAnswers: ['himself', 'herself', 'themselves'], multiSelect: true },
            { id: 'q3', text: 'The students congratulated _____ after the competition.', options: ['himself', 'themselves', 'each other', 'itself'], correctAnswers: ['themselves', 'each other'], multiSelect: true },
            { id: 'q4', text: 'This laptop is _____, not mine.', options: ['your', 'yours', 'hers', 'their'], correctAnswers: ['yours', 'hers'], multiSelect: true },
            { id: 'q5', text: 'Each applicant must submit _____ application before Friday.', options: ['their', 'his', 'her', 'its'], correctAnswers: ['their', 'his', 'her'], multiSelect: true },
            { id: 'q6', text: 'The award was given to Ana and _____.', options: ['me', 'him', 'her', 'them', 'I'], correctAnswers: ['me', 'him', 'her', 'them'], multiSelect: true },
            { id: 'q7', text: 'The choice is _____: we can leave now or wait.', options: ['ours', 'yours', 'our', 'your'], correctAnswers: ['ours', 'yours'], multiSelect: true }
        ]
    },
    'phrasal-verbs-2': {
        instructions: 'Drag each phrasal verb into the category that best matches its meaning.',
        dragDrop: {
            id: 'phrasal-verbs-2',
            items: [
                { id: 'i1', text: 'turn off' },
                { id: 'i2', text: 'turn on' },
                { id: 'i3', text: 'give up' },
                { id: 'i4', text: 'carry on' },
                { id: 'i5', text: 'find out' },
                { id: 'i6', text: 'look into' },
                { id: 'i7', text: 'set off' },
                { id: 'i8', text: 'get back' },
            ],
            zones: [
                { id: 'start-stop', label: 'Starting / Stopping' },
                { id: 'discover', label: 'Discovering / Investigating' },
                { id: 'movement', label: 'Movement / Journey' },
            ],
            correctMapping: {
                'start-stop': ['i1', 'i2', 'i3', 'i4'],
                discover: ['i5', 'i6'],
                movement: ['i7', 'i8'],
            }
        }
    },
    'used-to-2': {
        instructions: 'Fill in the correct form',
        questions: [
            { id: 'q1', text: 'I _____ tennis when I was younger.', correctAnswer: 'used to play', placeholderHint: 'play' },
            { id: 'q2', text: 'She _____ in Paris, but now she lives in London.', correctAnswer: 'used to live', placeholderHint: 'live' },
            { id: 'q3', text: 'They _____ vegetables, but now they do.', correctAnswer: 'didn\'t use to like', placeholderHint: 'not/like' },
            { id: 'q4', text: 'We _____ to the beach every summer.', correctAnswer: 'used to go', placeholderHint: 'go' },
            { id: 'q5', text: 'He _____ very shy, but now he\'s confident.', correctAnswer: 'used to be', placeholderHint: 'be' }
        ]
    },
    'would-rather-2': {
        instructions: 'Fill in the correct form',
        questions: [
            { id: 'q1', text: 'I _____ stay home rather than go to the party.', correctAnswers: ['would rather', 'prefer to'] },
            { id: 'q2', text: 'She _____ read a book rather than watch TV.', correctAnswers: ['would rather', 'prefers to'] },
            { id: 'q3', text: 'They _____ go to the cinema rather than go to the theater.', correctAnswers: ['would rather', 'prefer to'] },
            { id: 'q4', text: 'I _____ tea rather than coffee.', correctAnswers: ['prefer', 'would rather have'] },
            { id: 'q5', text: 'We _____ travel by train rather than by plane.', correctAnswers: ['would rather', 'prefer to'] }
        ]
    },
    // Advanced Level 3
    'perfect-tenses-3': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'I _____ my homework already.', correctAnswer: 'have finished', placeholderHint: 'finish' },
            { id: 'q2', text: 'She _____ here for five years.', correctAnswers: ['has lived', 'has been living'], placeholderHint: 'live' },
            { id: 'q3', text: 'By the time we arrived, they _____ .', correctAnswer: 'had left', placeholderHint: 'leave' },
            { id: 'q4', text: 'This is the first time I _____ such a beautiful sunset.', correctAnswer: 'have seen', placeholderHint: 'see' },
            { id: 'q5', text: 'He _____ here since 2020.', correctAnswers: ['has worked', 'has been working'], placeholderHint: 'work' },
            { id: 'q6', text: 'By next year, I _____ from university.', correctAnswer: 'will have graduated', placeholderHint: 'graduate' },
            { id: 'q7', text: 'She had already _____ before I called.', correctAnswer: 'eaten', placeholderHint: 'eat' },
            { id: 'q8', text: 'We _____ the project yet.', correctAnswer: 'have not finished', placeholderHint: 'not/finish' }
        ]
    },
    'conditionals-3': {
        instructions: 'Fill in the correct form of the verb (Third Conditional)',
        questions: [
            { id: 'q1', text: 'If I _____ harder, I would have passed the exam.', correctAnswer: 'had studied', placeholderHint: 'study' },
            { id: 'q2', text: 'If she _____ earlier, she wouldn\'t have missed the train.', correctAnswer: 'had left', placeholderHint: 'leave' },
            { id: 'q3', text: 'If we _____ about the party, we would have come.', correctAnswer: 'had known', placeholderHint: 'know' },
            { id: 'q4', text: 'If he _____ his keys, he could have entered.', correctAnswer: 'had not forgotten', placeholderHint: 'not/forget' },
            { id: 'q5', text: 'If they _____ on time, they would have seen the show.', correctAnswer: 'had arrived', placeholderHint: 'arrive' },
            { id: 'q6', text: 'If you _____ me, I would have helped right away.', correctAnswer: 'had called', placeholderHint: 'call' },
            { id: 'q7', text: 'If the weather _____ better, we could have gone sailing.', correctAnswer: 'had been', placeholderHint: 'be' },
            { id: 'q8', text: 'If I _____ the warning signs, I would have acted sooner.', correctAnswer: 'had noticed', placeholderHint: 'notice' }
        ]
    },
    'wish-if-only-3': {
        instructions: 'Fill in the correct form',
        questions: [
            { id: 'q1', text: 'I wish I _____ French fluently.', correctAnswer: 'spoke', placeholderHint: 'speak' },
            { id: 'q2', text: 'She wishes she _____ harder when she was younger.', correctAnswer: 'had studied', placeholderHint: 'study' },
            { id: 'q3', text: 'I wish it _____ today so we could have our picnic outdoors.', correctAnswers: ['weren\'t raining', 'wasn\'t raining'], placeholderHint: 'rain' },
            { id: 'q4', text: 'If only I _____ the answer!', correctAnswer: 'knew', placeholderHint: 'know' },
            { id: 'q5', text: 'He wishes he _____ that mistake.', correctAnswer: 'hadn\'t made', placeholderHint: 'not/make' },
            { id: 'q6', text: 'If only we _____ more time to prepare.', correctAnswer: 'had', placeholderHint: 'have' },
            { id: 'q7', text: 'She wishes she _____ so much coffee last night.', correctAnswer: 'hadn\'t drunk', placeholderHint: 'not/drink' },
            { id: 'q8', text: 'I wish I _____ what to say in that meeting.', correctAnswer: 'had known', placeholderHint: 'know' }
        ]
    },
    'mixed-tenses-3': {
        instructions: 'Fill in the correct form of the verb',
        questions: [
            { id: 'q1', text: 'I _____ English for five years, and I still learn new things every day.', correctAnswers: ['have been studying', 'have studied'], placeholderHint: 'study' },
            { id: 'q2', text: 'When I arrived at the station, the train had already _____.', correctAnswer: 'left', placeholderHint: 'leave' },
            { id: 'q3', text: 'She _____ here since 2020, and she is planning to stay for another year.', correctAnswers: ['has been working', 'has worked'], placeholderHint: 'work' },
            { id: 'q4', text: 'By the time you get home, I _____ cooking dinner.', correctAnswer: 'will have finished', placeholderHint: 'finish' },
            { id: 'q5', text: 'While I _____ a book, my phone rang.', correctAnswer: 'was reading', placeholderHint: 'read' },
            { id: 'q6', text: 'They _____ the project before the deadline, so they took a day off.', correctAnswers: ['completed', 'had completed'], placeholderHint: 'complete' },
            { id: 'q7', text: 'At this time next week, we _____ in the final workshop session.', correctAnswer: 'will be participating', placeholderHint: 'participate' },
            { id: 'q8', text: 'She usually _____ tea in the morning, but today she chose coffee.', correctAnswer: 'drinks', placeholderHint: 'drink' }
        ]
    },
    'prepositions-3': {
        instructions: 'Fill in the correct preposition',
        questions: [
            { id: 'q1', text: 'The final decision rests _____ the board of directors.', correctAnswer: 'with' },
            { id: 'q2', text: 'Her argument is based _____ recent survey data.', correctAnswer: 'on' },
            { id: 'q3', text: 'The company complied _____ all safety regulations.', correctAnswer: 'with' },
            { id: 'q4', text: 'We succeeded _____ reducing production costs this quarter.', correctAnswer: 'in' },
            { id: 'q5', text: 'The report is divided _____ three main sections.', correctAnswer: 'into' },
            { id: 'q6', text: 'He is responsible _____ overseeing the new interns.', correctAnswer: 'for' },
            { id: 'q7', text: 'The policy is aimed _____ improving access to healthcare.', correctAnswer: 'at' },
            { id: 'q8', text: 'There has been a steady increase _____ demand for electric buses.', correctAnswer: 'in' },
            { id: 'q9', text: 'The committee objected _____ the proposed timeline.', correctAnswer: 'to' },
            { id: 'q10', text: 'Their conclusions are consistent _____ earlier findings.', correctAnswer: 'with' }
        ]
    },
    'comparisons-3': {
        instructions: 'Fill in the correct comparative or superlative form',
        questions: [
            { id: 'q1', text: 'Among all proposals, Maria\'s was by far the _____.', correctAnswer: 'most convincing', placeholderHint: 'convincing' },
            { id: 'q2', text: 'The revised policy explains every rule clearly, so it is _____ than the vague previous version.', correctAnswer: 'more transparent', placeholderHint: 'transparent' },
            { id: 'q3', text: 'No other candidate responded _____ under pressure than Lee.', correctAnswer: 'better', placeholderHint: 'well' },
            { id: 'q4', text: 'This is the _____ dataset we have worked with this year.', correctAnswer: 'most complex', placeholderHint: 'complex' },
            { id: 'q5', text: 'The northern route used more fuel and took longer, so it was _____ than expected.', correctAnswer: 'less efficient', placeholderHint: 'efficient' },
            { id: 'q6', text: 'Of the three conclusions, the last relies on the fewest assumptions, so it is the _____.', correctAnswer: 'least speculative', placeholderHint: 'speculative' },
            { id: 'q7', text: 'Her explanation included exact measurements, so it was _____ than mine.', correctAnswer: 'more precise', placeholderHint: 'precise' },
            { id: 'q8', text: 'Customer growth reached its highest rate since 2021, making this quarter the _____ period.', correctAnswer: 'strongest', placeholderHint: 'strong' },
            { id: 'q9', text: 'The second draft reads _____ than the first draft.', correctAnswer: 'more smoothly', placeholderHint: 'smoothly' },
            { id: 'q10', text: 'That objection threatened the entire proposal, making it the _____ one raised during the hearing.', correctAnswer: 'most serious', placeholderHint: 'serious' }
        ]
    },
    'pronouns-3': {
        instructions: 'Select ALL pronoun forms that grammatically fit in the blank.',
        questions: [
            { id: 'q1', text: 'If anyone calls, tell _____ that I will return in ten minutes.', options: ['them', 'him', 'her', 'it'], correctAnswers: ['them', 'him', 'her'], multiSelect: true },
            { id: 'q2', text: 'The committee, acting as a single body, gave _____ two weeks to submit the final draft.', options: ['itself', 'themselves', 'theirs', 'it'], correctAnswers: ['itself'], multiSelect: true },
            { id: 'q3', text: 'Neither the manager nor the assistants blamed _____.', options: ['themselves', 'himself', 'each other', 'itself'], correctAnswers: ['themselves', 'each other'], multiSelect: true },
            { id: 'q4', text: 'Between you and _____, this proposal needs major revision.', options: ['me', 'I', 'myself', 'mine'], correctAnswers: ['me'], multiSelect: true },
            { id: 'q5', text: 'The researchers compared their results with _____ from last year.', options: ['those', 'that', 'them', 'these'], correctAnswers: ['those'], multiSelect: true },
            { id: 'q6', text: 'The candidate to _____ we sent the email replied immediately.', options: ['whom', 'who', 'which', 'whose'], correctAnswers: ['whom', 'who'], multiSelect: true },
            { id: 'q7', text: 'Each of the participants should bring _____ own device.', options: ['their', 'his', 'her', 'its'], correctAnswers: ['their', 'his', 'her'], multiSelect: true },
            { id: 'q8', text: 'Each board member asked _____ whether the deadline was realistic.', options: ['themselves', 'himself', 'herself', 'each other'], correctAnswers: ['themselves', 'himself', 'herself'], multiSelect: true },
            { id: 'q9', text: 'This recommendation is not ours; it is _____.', options: ['theirs', 'their', 'them', 'they'], correctAnswers: ['theirs'], multiSelect: true },
            { id: 'q10', text: 'No one except Maya and _____ knew about the schedule change.', options: ['me', 'I', 'myself', 'mine'], correctAnswers: ['me'], multiSelect: true }
        ]
    },
    'articles-3': {
        instructions: 'Fill in the correct article',
        questions: [
            { id: 'q1', text: 'She has _____ deep understanding of syntax.', correctAnswer: 'a', options: ['a', 'an', 'the', ''] },
            { id: 'q2', text: '_____ only research study conducted in 2024 changed our approach.', correctAnswer: 'The', options: ['A', 'An', 'The', ''] },
            { id: 'q3', text: 'They elected her _____ chair of the committee.', correctAnswer: '', options: ['a', 'an', 'the', ''] },
            { id: 'q4', text: 'He is _____ heir to a large estate.', correctAnswer: 'an', options: ['a', 'an', 'the', ''] },
            { id: 'q5', text: '_____ Nile is one of the longest rivers in the world.', correctAnswer: 'The', options: ['A', 'An', 'The', ''] },
            { id: 'q6', text: 'We need _____ information before making a decision.', correctAnswer: '', options: ['a', 'an', 'the', ''] },
            { id: 'q7', text: 'She plays _____ violin professionally.', correctAnswer: 'the', options: ['a', 'an', 'the', ''] },
            { id: 'q8', text: 'After lunch, we visited _____ museum we had discussed near the station.', correctAnswer: 'the', options: ['a', 'an', 'the', ''] },
            { id: 'q9', text: 'He was appointed _____ director of the institute last year.', correctAnswer: '', options: ['a', 'an', 'the', ''] },
            { id: 'q10', text: '_____ Earth revolves around the Sun.', correctAnswers: ['The', ''], options: ['A', 'An', 'The', ''] }
        ]
    },
    'modal-verbs-3': {
        instructions: 'Select every modal form that expresses the precise meaning stated.',
        questions: [
            { id: 'q1', text: 'The evidence makes it impossible that he is at home: He _____ be there.', options: ['can\'t', 'cannot', 'must not', 'shouldn\'t'], correctAnswers: ['can\'t', 'cannot'], multiSelect: true },
            { id: 'q2', text: 'This is criticism about a past action: You _____ have told me earlier.', options: ['should', 'could', 'must', 'might'], correctAnswers: ['should'], multiSelect: true },
            { id: 'q3', text: 'This is an uncertain possibility: They _____ have missed the train.', options: ['might', 'may', 'could', 'should'], correctAnswers: ['might', 'may', 'could'], multiSelect: true },
            { id: 'q4', text: 'This is a firm application requirement: Applicants _____ submit all documents by Friday.', options: ['must', 'should', 'can', 'might'], correctAnswers: ['must'], multiSelect: true },
            { id: 'q5', text: 'Helping was my firm intention: If you had asked, I _____ have helped.', options: ['would', 'could', 'should', 'might'], correctAnswers: ['would'], multiSelect: true },
            { id: 'q6', text: 'The appointment is possible but unconfirmed: She _____ be the new director.', options: ['may', 'might', 'must', 'can'], correctAnswers: ['may', 'might'], multiSelect: true },
            { id: 'q7', text: 'These forms express a formal prohibition: You _____ smoke here under any circumstances.', options: ['must not', 'should not', 'cannot', 'may not'], correctAnswers: ['must not', 'cannot', 'may not'], multiSelect: true },
            { id: 'q8', text: 'This expresses an expectation: By now, they _____ have received our email.', options: ['should', 'must', 'might', 'can'], correctAnswers: ['should'], multiSelect: true },
            { id: 'q9', text: 'This is criticism about a past action: You _____ have checked the figures first.', options: ['should', 'must', 'could', 'might'], correctAnswers: ['should'], multiSelect: true },
            { id: 'q10', text: 'The different style makes authorship impossible: He _____ be the author.', options: ['can\'t', 'cannot', 'shouldn\'t', 'might not'], correctAnswers: ['can\'t', 'cannot'], multiSelect: true }
        ]
    },
    'sentence-structure-3': {
        instructions: 'Fill in the missing structure',
        questions: [
            { id: 'q1', text: 'Not only _____ the team finish early, but it also reduced costs.', correctAnswer: 'did' },
            { id: 'q2', text: 'Rarely _____ we see such a detailed analysis.', correctAnswer: 'do' },
            { id: 'q3', text: 'Had I known earlier, I _____ have changed the schedule.', correctAnswer: 'would' },
            { id: 'q4', text: 'No sooner _____ she arrived than the meeting began.', correctAnswer: 'had' },
            { id: 'q5', text: 'The report, _____ was revised twice, is now ready.', correctAnswer: 'which' },
            { id: 'q6', text: 'Only after the audit _____ they identify the error.', correctAnswer: 'did' },
            { id: 'q7', text: 'So complex _____ the issue that we needed external advice.', correctAnswer: 'was' },
            { id: 'q8', text: 'Seldom _____ this method produce unreliable results.', correctAnswer: 'does' },
            { id: 'q9', text: 'Not until the final chapter _____ the main conflict resolved.', correctAnswers: ['is', 'was'] },
            { id: 'q10', text: 'Hardly ever _____ we encounter such a consistent dataset.', correctAnswer: 'do' }
        ]
    },
    'verb-patterns-3': {
        instructions: 'Fill in the correct verb pattern',
        questions: [
            { id: 'q1', text: 'The manager encouraged us _____ the proposal.', correctAnswer: 'to revise', placeholderHint: 'revise' },
            { id: 'q2', text: 'I remember _____ this author years ago.', correctAnswer: 'reading', placeholderHint: 'read' },
            { id: 'q3', text: 'She admitted _____ the deadline.', correctAnswer: 'missing', placeholderHint: 'miss' },
            { id: 'q4', text: 'They appear _____ the issue quickly.', correctAnswer: 'to have solved', placeholderHint: 'solve' },
            { id: 'q5', text: 'We would rather _____ the launch until Monday.', correctAnswer: 'delay', placeholderHint: 'delay' },
            { id: 'q6', text: 'He denied _____ the confidential file.', correctAnswer: 'sharing', placeholderHint: 'share' },
            { id: 'q7', text: 'The team seems _____ efficiently under pressure.', correctAnswers: ['to work', 'to be working'], placeholderHint: 'work' },
            { id: 'q8', text: 'I regret _____ so long to respond.', correctAnswers: ['waiting', 'having waited'], placeholderHint: 'wait' },
            { id: 'q9', text: 'She pretended _____ the announcement before anyone else.', correctAnswer: 'to have seen', placeholderHint: 'see' },
            { id: 'q10', text: 'We considered _____ the pilot in two regions first.', correctAnswer: 'running', placeholderHint: 'run' }
        ]
    },
    'voice-clauses-3': {
        instructions: 'Fill in the correct form',
        questions: [
            { id: 'q1', text: 'The proposal _____ by the board after extensive debate.', correctAnswer: 'was approved', placeholderHint: 'approve' },
            { id: 'q2', text: 'The analyst, _____ report was cited widely, joined the panel.', correctAnswer: 'whose' },
            { id: 'q3', text: 'By next month, the system _____ fully tested.', correctAnswers: ['will have been', 'will be'] },
            { id: 'q4', text: 'This is the framework _____ we based our methodology.', correctAnswer: 'on which' },
            { id: 'q5', text: 'She said the data _____ independently verified.', correctAnswers: ['had been', 'was'] },
            { id: 'q6', text: 'The candidates _____ selected will be notified tomorrow.', correctAnswers: ['who were', 'that were', 'selected'] },
            { id: 'q7', text: 'The policy, _____ was introduced last year, remains controversial.', correctAnswer: 'which' },
            { id: 'q8', text: 'In the completed study, the results _____ in accordance with international standards.', correctAnswer: 'were interpreted', placeholderHint: 'interpret' },
            { id: 'q9', text: 'The expert to _____ we referred clarified the methodology.', correctAnswers: ['whom', 'who'] },
            { id: 'q10', text: 'By the end of the quarter, all units _____ inspected.', correctAnswers: ['will have been', 'will be'] }
        ]
    },
    'drag-drop-tenses': {
        instructions: `Sort each sentence into the correct tense category.`,
        dragDrop: {
            id: 'drag-drop-tenses',
            items: [
                { id: 'i1', text: 'She walks to school every morning.' },
                { id: 'i2', text: 'They visited the museum last weekend.' },
                { id: 'i3', text: 'We will finish the project by Friday.' },
                { id: 'i4', text: 'He always drinks coffee after lunch.' },
                { id: 'i5', text: 'I called her yesterday but she didn\'t answer.' },
                { id: 'i6', text: 'It will rain tomorrow, according to the forecast.' },
            ],
            zones: [
                { id: 'present', label: 'Present Simple' },
                { id: 'past', label: 'Past Simple' },
                { id: 'future', label: 'Future Simple' },
            ],
            correctMapping: {
                present: ['i1', 'i4'],
                past: ['i2', 'i5'],
                future: ['i3', 'i6'],
            }
        }
    }
};
